const countries = [
{
"name": "Nigeria",
"dial_code": "+234",
"code": "NG"
},
{
"name": "Poland",
"dial_code": "+48",
"code": "PL"
},
{
"name": "Portugal",
"dial_code": "+351",
"code": "PT"
},
{
"name": "Puerto Rico",
"dial_code": "+1939",
"code": "PR"
},
{
"name": "Qatar",
"dial_code": "+974",
"code": "QA"
},
{
"name": "South Africa",
"dial_code": "+27",
"code": "ZA"
},
{
"name": "Turkey",
"dial_code": "+90",
"code": "TR"
},
{
"name": "Uganda",
"dial_code": "+256",
"code": "UG"
},
{
"name": "Ukraine",
"dial_code": "+380",
"code": "UA"
},
{
"name": "United Kingdom",
"dial_code": "+44",
"code": "GB"
},
{
"name": "United States",
"dial_code": "+1",
"code": "US"
},
{
"name": "Ghana",
"dial_code": "+233",
"code": "GH"
},
{
"name": "Kenya",
"dial_code": "+254",
"code": "KE"
},
{
"name": "Netherlands",
"dial_code": "+31",
"code": "NL"
},
{
"name": "Niger",
"dial_code": "+227",
"code": "NE"
},
];

export default countries;

